
import { RouteCutoffFormComponent } from "../directives/rostering-cut-off/directives/route-cutoff-form/route-cutoff-form.component";
import { RouteCutoffViewComponent } from "../directives/rostering-cut-off/directives/route-cutoff-view/route-cutoff-view.component";
import { RosteringCutOffComponent } from "../directives/rostering-cut-off/rostering-cut-off.component";
import { RouteConfigurationComponent } from "./route-configuration.component";
import { RouteHolidayConfigComponent } from "./route-holiday-config/route-holiday-config.component";
import { RouteHolidayFormComponent } from "./route-holiday-config/route-holiday-form/route-holiday-form.component";
import { RouteHolidayViewComponent } from "./route-holiday-config/route-holiday-view/route-holiday-view.component";

export const routeConfigDeclartion = [
    
    RouteConfigurationComponent,

    RosteringCutOffComponent,
    RouteCutoffFormComponent,
    RouteCutoffViewComponent,
    
    RouteHolidayConfigComponent,
    RouteHolidayFormComponent,
    RouteHolidayViewComponent,
]